import Swal from 'sweetalert2';
import { ALERT_COLORS } from '../constants/alert';
import { AlertConfig } from '../types/alert';
import { defaultLogoBlackSVG } from '../utils/constants';

export const showErrorAlert = (config: AlertConfig): void => {
    Swal.fire({
        html: `
      <div style="text-align: center; padding: 20px 20px 0px 20px;">
        <!-- <div style="width: 100px; height: 100px; border-radius: 50%; margin: 0 auto 30px; display: flex; align-items: center; justify-content: center;">
          <img src="${defaultLogoBlackSVG}" style="width:100%; height:100%;" />
        </div> -->
        <h2 style="font-family: Oswald, sans-serif; font-weight: 500; color: ${ALERT_COLORS.primary}; font-size: 32px; margin-bottom: 20px; line-height: 1.2; text-transform: capitalize;">
          ${config.title}
        </h2>
        <p style="font-family: Satoshi, sans-serif; font-weight: 300; color: ${ALERT_COLORS.secondary}; font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
          ${config.message}
        </p>
        ${config.errorCode ? `
          <p style="font-family: Satoshi, sans-serif; font-weight: 300; color: ${ALERT_COLORS.tertiary}; font-size: 12px; line-height: 1.4;">
            
          </p>
        ` : ''}
      </div>
    `,
        showCloseButton: false,
        showConfirmButton: true,
        confirmButtonText: config.confirmButtonText || 'Close',
        customClass: {
            popup: 'custom-popup',
            confirmButton: 'nb-link-underline-500 mb-10',
        },
        buttonsStyling: false,
    }).then((result) => {
        if (result.isConfirmed && config.onConfirm) {
            config.onConfirm();
        }
    });
};